import { amountFormatter } from '../../utils/utils';
import { useMediaQuery } from 'react-responsive';
import constant from '../../utils/constant';
import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { transactionStore } from '../../stores';
import MimaOptionMenu from '../../components/OptionMenu/';
import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { MimaText, Searchbar } from '../../components';

const Expenses = ({
	transactions,
	filteredTransactions,
	setFilteredTransactions,
	setViewMoreExpense,
}) => {
	const [showList, setShowList] = useState(false);
	const [tableList, setTableList] = useState({
		key: constant.FLOW_TYPE.All,
		value: 'Type',
	});

	const data = [
		{
			key: constant.FLOW_TYPE.All,
			value: 'All',
		},
		{
			key: constant.FLOW_TYPE.Withdraw,
			value: 'Withdrawal',
		},
		{
			key: constant.FLOW_TYPE.Expense,
			value: 'Expense',
		},
	];

	const allExpense = useMemo(() => {
		const allExpense = transactions.filter(item => {
			return item.type === 'OUTFLOW';
		});
		return allExpense;
	}, [transactions]);

	const tableData = useMemo(() => {
		const tableData = allExpense.filter(inflow => {
			if (tableList.key === constant.FLOW_TYPE.All) {
				return true;
			} else {
				return inflow.inflowType === tableList.key;
			}
		});
		return tableData;
	}, [allExpense, tableList]);

	const isBelow600 = useMediaQuery({
		query: '(max-width: 600px)',
	});

	const handleOptionSelect = (_id, transaction, option) => {
		transactionStore.setSelectedTransaction(transaction);
		if (option.value === 'View More') {
			setViewMoreExpense(true);
		}
	};

	return (
		<>
			<div className="searchInMiddle">
				<div className="searchInMiddle_filter">
					<div
						className={styles.tableButton}
						onClick={() => {
							setShowList(!showList);
						}}>
						{tableList.value}
						<span className={showList && styles.tableButton_active}>
							<MdKeyboardArrowDown size="20" />
						</span>
					</div>
					{showList && (
						<>
							{data.map((x, i) => (
								<div
									className={styles.dropDown}
									onClick={() => {
										setTableList(x);
										// setTableDetails(x.value)
										setShowList(false);
									}}
									key={i}>
									{x.value}
								</div>
							))}
						</>
					)}
				</div>
				<div className="searchInMiddle_search">
					<Searchbar
						placeholder="Search Transactions"
						variant="wide"
						input={tableData}
						loading={false}
						output={setFilteredTransactions}
						handleFilter={(item, searchQuery) => {
							return item?.customer?.fullname
								?.toLowerCase()
								?.includes(searchQuery) || item.expenseCategory
								? item.expenseCategory.name
										?.toLowerCase()
										?.includes(searchQuery)
								: '' ||
										item?.narration?.toLowerCase()?.includes(searchQuery) ||
										item?.inflowType?.toLowerCase()?.includes(searchQuery);
						}}
					/>
				</div>
			</div>

			<div className="whiteTable">
				<table>
					<thead>
						<tr>
							<th>Created Date </th>
							<th>Category</th>
							<th>Narration</th>
							{!isBelow600 && <th> Amount Charged </th>}
							<th> Amount Paid </th>
							<th> Balance </th>
							{!isBelow600 && <th> Tag Type </th>}
							<th>Status</th>
							<th></th>
						</tr>
					</thead>
					{filteredTransactions.length === 0 ? (
						<tbody className={styles.noRecord}>
							<MimaText variant="subtitleBold" mt={5} mb={5}>
								No Record Found
							</MimaText>
						</tbody>
					) : (
						<tbody>
							{filteredTransactions.map((transaction, index) => (
								<tr key={index} className={styles.row}>
									<td>
										{moment(transaction.createdAt).format('DD-MM-YYYY hh:mm')}{' '}
									</td>
									<td>
										{transaction.expenseCategory
											? transaction.expenseCategory.name
											: ''}
									</td>
									<td>{transaction.narration}</td>
									{!isBelow600 && (
										<td>
											{amountFormatter(transaction.currencyCode).format(
												transaction.transactionAmount || 0
											)}
										</td>
									)}
									<td>
										{amountFormatter(transaction.currencyCode).format(
											transaction.amountPaid || 0
										)}
									</td>
									<td>
										{amountFormatter(transaction.currencyCode).format(
											transaction.balanceAmount || 0
										)}
									</td>
									{!isBelow600 && <td>{transaction?.inflowType}</td>}
									<td
										className={`${
											transaction.status === 'UNPAID'
												? styles.notPaid
												: transaction.status === 'PAID'
													? styles.paid
													: styles.partPaid
										}`}>
										{transaction?.status}
									</td>

									<td style={{ cursor: 'pointer' }}>
										<MimaOptionMenu
											options={[
												{
													value: 'View More',
													label: 'View More',
												},
												transaction.category === 'OFFLINE' &&
													transaction.status !== 'VOID' && {
														value: 'Update Expense',
														label: 'Update Expense',
													},
											]}
											onOptionSelected={option => {
												handleOptionSelect(
													transaction._id,
													transaction,
													option
												);
											}}
										/>
									</td>
								</tr>
							))}
						</tbody>
					)}
				</table>
			</div>
		</>
	);
};

export default Expenses;
